import classNames from 'classnames';
import React from 'react';
import styles from './ColorDot.module.scss';
function ColorDot({ color = 'var(--status-color-neutral)', size = 'm', icon }) {
    if (icon) {
        return (React.createElement("span", { className: classNames(styles.icon, styles[size]), style: { ['--icon-color']: color } }, icon));
    }
    return (React.createElement("span", { className: classNames(styles.dot, styles[size]), style: { ['--dot-color']: color } }));
}
export default ColorDot;
